import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

export function getReviewerAssignmentsCount(): Promise<{ count: number }> {
  return FetchPromise.get('challenge_reviewer_assignments/count');
}

export function useReviewerAssignmentsCountQuery(queryOptions: UseQueryOptions<{ count: number }, JQuery.jqXHR> = {}) {
  return useQuery({
    queryKey: ['challenge-reviewer-assignments-count'],
    queryFn: getReviewerAssignmentsCount,
    ...queryOptions,
  });
}
